// extracted by mini-css-extract-plugin
module.exports = {"delta2_group3":"Group3_delta2_group3__3sXwr"};